module.exports = __webpack_public_path__ + "img/about-3.452dc4aa.jpg";